import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './ProviderRequests.html';
import ProviderRequestsService from './ProviderRequestsService';
import { Toaster } from '../../Services/toast';
import { ProviderRequestsModel } from './ProviderRequestsModel';
import { FilterModel } from './FilterModel';

interface RequestStatusOption {
    id: number;
    name: string;
}

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ProviderRequestsService,
    ],
})
export default class ProviderRequests extends Vue {
    @Inject(ProviderRequestsService) public providerRequestsService!: ProviderRequestsService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    public createdDateFromMenu: boolean = false;
    public createdDateToMenu: boolean = false;
    public pagination: any = {
        page: 1, rowsPerPage: 10, sortBy: 'createdDate', descending: true,
    };
    public isSorted: boolean = true;
    public selected: ProviderRequestsModel[] = [];
    public selectedIds: string[] = [];
    public bulkApproveMode: boolean = false;
    public bulkRejectMode: boolean = false;

    public headers: any = [];
    public providerRequests: ProviderRequestsModel[] = [];
    public providerRequestsCount: number = 0;
    public rejectResone: string = '';
    public rejectdialog: boolean = false;
    public requestId = '';
    public approveDialog: boolean = false;
    public filterModel: FilterModel = {
        name: '',
        enterpriseUnifiedNumber: '',
        accreditationNumber: '',
        taxNumber: '',
        createdDateFrom: '',
        createdDateTo: '',
        requestStatus: 0,
    };
    public requestStatusList: RequestStatusOption[] = [];
    private searchDebounceId: any = null;

    public created() {
        this.initHeaders();
        this.requestStatusList = this.buildRequestStatusList();
        this.$emit('childinit', this.layoutSup);
    }

    public async mounted() {
        await this.loadPage();
    }

    public initHeaders() {
        this.headers = [
            { text: this.$t('shared.name'), value: 'name', align: 'center', sortable: false },
            { text: this.$t('shared.enterpriseUnifiedNumber'), value: 'enterpriseUnifiedNumber', align: 'center', sortable: false },
            { text: this.$t('shared.accreditationNumber'), value: 'accreditationNumber', align: 'center', sortable: false },
            { text: this.$t('shared.taxNumber'), value: 'taxNumber', align: 'center', sortable: false },
            { text: this.$t('shared.createdDate'), value: 'createdDate', align: 'center', sortable: true, width: '160' },
            {
                text: this.$t('dashboardPage.status'),
                sortable: false, value: 'providerRequestStatus', align: 'center',
            },
            { text: this.$t('shared.actions'), sortable: false, align: 'center', width: '145' },
        ];
    }

    public buildRequestStatusList(): RequestStatusOption[] {
        return [
            { id: 0, name: this.$t('shared.all').toString() },
            { id: 1, name: this.$t('shared.PendingApproval').toString() },
            { id: 2, name: this.$t('shared.Approved').toString() },
            { id: 3, name: this.$t('shared.Rejected').toString() },
        ];
    }

    public onInputFilterDebounced() {
        if (this.searchDebounceId) {
            clearTimeout(this.searchDebounceId);
        }
        this.searchDebounceId = setTimeout(() => {
            this.search();
        }, 800);
    }

    public onRequestStatusFilterChange() {
        this.search();
    }

    public async search() {
        this.clearSelection();
        this.pagination.page = 1;
        await this.loadPage();
    }

    public clearSelection() {
        this.selected = [];
        this.selectedIds = [];
    }

    public onDateChange(field: 'from' | 'to') {
        if (field === 'from') {
            this.createdDateFromMenu = false;
        } else {
            this.createdDateToMenu = false;
        }
        this.search();
    }

    public async reset() {
        this.filterModel = {
            name: '',
            enterpriseUnifiedNumber: '',
            accreditationNumber: '',
            taxNumber: '',
            createdDateFrom: '',
            createdDateTo: '',
            requestStatus: 0,
        };
        this.pagination = { page: 1, rowsPerPage: 10, sortBy: 'createdDate', descending: true };
        this.clearSelection();
        await this.loadPage();
    }

    public changeSort(column: string) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
        } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
        }
        this.isSorted = true;
        this.clearSelection();
        this.updatePaginate(this.pagination);
    }

    public async loadPage() {
        const pageIndex = (this.pagination.page - 1) || 0;
        const response = await this.providerRequestsService.Get(
            this.filterModel.name,
            this.filterModel.enterpriseUnifiedNumber,
            this.filterModel.accreditationNumber,
            this.filterModel.taxNumber,
            pageIndex.toString(),
            this.pagination.rowsPerPage.toString(),
            this.filterModel.createdDateFrom,
            this.filterModel.createdDateTo,
            this.filterModel.requestStatus == null ? 0 : this.filterModel.requestStatus,
            (this.pagination.sortBy === 'createdDate' || !this.pagination.sortBy) ? 'createdDate' : 'createdDate',
            this.pagination.descending,
        );
        if (response === false) {
            return;
        }
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.providerRequests = response.result;
        this.providerRequestsCount = response.totalCount;
    }

    public async updatePaginate(val: any) {
        const response = await this.providerRequestsService.Get(
            this.filterModel.name,
            this.filterModel.enterpriseUnifiedNumber,
            this.filterModel.accreditationNumber,
            this.filterModel.taxNumber,
            (val.page - 1).toString(),
            val.rowsPerPage,
            this.filterModel.createdDateFrom,
            this.filterModel.createdDateTo,
            this.filterModel.requestStatus == null ? 0 : this.filterModel.requestStatus,
            (this.pagination.sortBy === 'createdDate' || !this.pagination.sortBy) ? 'createdDate' : 'createdDate',
            this.pagination.descending,
        );
        if (response === false) {
            return;
        }
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.providerRequests = response.result;
        this.providerRequestsCount = response.totalCount;
        this.pagination.page = val.page;
        this.pagination.rowsPerPage = val.rowsPerPage;
        this.clearSelection();
    }

    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedIds = [];
        } else {
            this.selected = this.providerRequests.slice();
            this.selectedIds = this.providerRequests.map((x) => x.id);
        }
    }
    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            if (index > -1) {
                this.selectedIds.splice(index, 1);
            }
        } else if (this.selectedIds.indexOf(id) === -1) {
            this.selectedIds.push(id);
        }
    }

    public get canBulkActionPendingOnly(): boolean {
        if (this.selectedIds.length === 0) {
            return false;
        }
        return this.selectedIds.every((sid) => {
            const row = this.providerRequests.find((p) => p.id === sid);
            return row !== undefined && row.providerRequestStatus === 1;
        });
    }

    public GetProviderRequestStatus(typeStatus: number) {
        switch (typeStatus) {
            case 1: {
                return this.$t('shared.PendingApproval').toString();
            }
            case 2: {
                return this.$t('shared.Approved').toString();
            }
            case 3: {
                return this.$t('shared.Rejected').toString();
            }
        }
        return '';
    }

    /** Shows yyyy-MM-dd only (strips time if API sends "YYYY-MM-DD HH:mm" or ISO). */
    public formatCreatedDateOnly(value: string | undefined | null): string {
        if (value == null || value === '') {
            return '';
        }
        const s = String(value).trim();
        const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
        return m ? m[1] : s;
    }

    public async showRejectDialog(id?: string) {
        this.bulkRejectMode = !id;
        if (id) {
            this.requestId = id;
        } else {
            this.requestId = '';
        }
        this.rejectdialog = true;
    }
    public async hideRejectDialog() {
        this.rejectResone = '';
        this.requestId = '';
        this.bulkRejectMode = false;
        this.rejectdialog = false;
    }
    public showapproveDialog(id?: string) {
        this.bulkApproveMode = !id;
        this.requestId = id || '';
        this.approveDialog = true;
    }
    public hideapproveDialog() {
        this.bulkApproveMode = false;
        this.approveDialog = false;
    }
    public async reject() {
        if (this.rejectResone === '') {
            return;
        }
        if (this.bulkRejectMode && this.selectedIds.length) {
            const response = await this.providerRequestsService.rejectBulk(this.selectedIds, this.rejectResone);
            if (response === false) {
                Toaster.error(this.$t('shared.errorOccurred').toString());
            } else if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                this.hideRejectDialog();
                this.rejectResone = '';
                Toaster.success(this.$t('shared.RejectedRequestSuccessfully').toString());
                await this.loadPage();
            }
        } else {
            const response = await this.providerRequestsService.reject(this.requestId, this.rejectResone);
            if (response === false) {
                Toaster.error(this.$t('shared.errorOccurred').toString());
            } else if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                this.hideRejectDialog();
                this.rejectResone = '';
                Toaster.success(this.$t('shared.RejectedRequestSuccessfully').toString());
                await this.loadPage();
            }
        }
    }
    public async approve() {
        if (this.bulkApproveMode && this.selectedIds.length) {
            const response = await this.providerRequestsService.approveBulk(this.selectedIds);
            if (response === false) {
                Toaster.error(this.$t('shared.errorOccurred').toString());
            } else if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                Toaster.success(this.$t('shared.ApprovedRequestSuccessfully').toString());
                this.clearSelection();
                await this.loadPage();
            }
        } else {
            const response = await this.providerRequestsService.approve(this.requestId);
            if (response === false) {
                Toaster.error(this.$t('shared.errorOccurred').toString());
            } else if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                Toaster.success(this.$t('shared.ApprovedRequestSuccessfully').toString());
                await this.loadPage();
            }
        }
        this.hideapproveDialog();
    }

    public Details(id: string) {
        this.$router.push({ name: 'ProviderRequestInfo', params: { id } });
    }

    public get rejectReasonIsValid(): boolean {
        return this.rejectResone !== '';
    }

}
